import React from "react";

const GlobalFedDropdownContext = React.createContext({});

export default GlobalFedDropdownContext;
